module.exports = __webpack_public_path__ + "img/undraw_city_girl_ccpd.cf31c9ee.svg";